<template>
  <div id="units">
    <v-container fluid>
      <v-flex xs12>
        <HowToUseThisPage />
        <div class="units-container">
          <div class="route-container mb-4 section-heading">
            <h1>
              <BookMark :color="iconColor" class="units-icon" />
              {{ $t('units.pageTitle') }}
            </h1>
          </div>
          <v-flex class="d-flex mb-7 mt-12">
            <div class="">
              <v-btn
                v-if="!openUnitsForm && !editingUnit"
                color="rgba(165, 216, 103, 1)"
                class="elevation-0 font-weight-bold"
                @click="addNewHandler"
                >{{ $t('units.createNewUnit') }}</v-btn
              >
              <div v-else class="close-link" @click="closebuilder">
                <v-icon>arrowleft</v-icon>
                <span class="close-link-text">{{ $t('units.close') }}</span>
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-text-field
              v-if="!openUnitsForm && !editingUnit"
              v-model="search"
              :append-inner-icon="search ? '' : 'mdi-magnify'"
              :label="$t('units.search')"
              single-line
              hide-details
              clearable
              variant="solo"
              flat
              density="compact"
              color="#E8E9EC"
              style="max-width: 265px"
            ></v-text-field>
          </v-flex>
          <NewUnit
            v-if="openUnitsForm"
            :allCategories="allCategories"
            @closeUnitsForm="closeUnitsFormChild"
          />
          <EditUnit
            v-if="editingUnit"
            :unitbackdoor="unitbackdoor"
            :unit="unitToEdit"
            :allCategories="allCategories"
            @closeEditUnitsForm="closeEditUnitsFormChild"
          />
          <v-data-table
            :headers="adminActions"
            fixed-header
            :loading="isloading"
            :loading-text="$t('units.loadingUnits')"
            :no-data-text="$t('units.noUnitsCreated')"
            :items="units"
            :items-per-page="20"
            :header-props="{ sortIcon: '$sortarrowdown' }"
            :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50] }"
            :search="search"
            class="elevation-1 users-table"
          >
            <template #progress>
              <v-progress-linear
                color="#592892"
                indeterminate
              ></v-progress-linear>
            </template>

            <template #[`item.sections`]="{ item }">
              <div class="action-icons">
                {{ sectionsUsingThisUnit(item) }}
              </div>
            </template>

            <template #[`item.courses`]="{ item }">
              <div class="action-icons">
                {{ coursesUsingThisUnit(item) }}
              </div>
            </template>

            <template #[`item.title`]="{ item }">
              <div class="d-flex align-center">
                <span class="mr-2">{{ item.title }}</span>
                <div class="d-flex align-center">
                  <v-chip
                    v-for="lang in getAvailableLanguages(item)"
                    :key="lang.code"
                    size="x-small"
                    :color="getLanguageColor(lang.code)"
                    variant="outlined"
                    class="mr-1"
                  >
                    {{ lang.code.toUpperCase() }}
                  </v-chip>
                </div>
              </div>
            </template>

            <template v-if="isAuthenticated" #[`item.type`]="{ item }">
              <v-chip
                v-if="
                  item.cid == churchid ||
                  checkAuthorization(['superAdmin']).length > 0
                "
                class="px-7"
                :class="[
                  item.verified == 'verified'
                    ? isDarkTheme
                      ? 'text-grey-lighten-3'
                      : 'text-black'
                    : isDarkTheme
                    ? 'text-black'
                    : 'text-grey-lighten-6',
                ]"
                :color="
                  item.verified == 'verified' ? 'rgba(165, 216, 103, .32)' : ''
                "
                variant="flat"
              >
                {{ $helpers.uppercase(item.type) }}
              </v-chip>
            </template>

            <template #[`item.status`]="{ item }">
              <v-chip
                :class="
                  item.status === 'published'
                    ? isDarkTheme
                      ? 'text-grey-lighten-3'
                      : 'text-black'
                    : isDarkTheme
                    ? 'text-black'
                    : 'text-grey-lighten-6'
                "
                :color="
                  item.status == 'published' ? 'rgba(165, 216, 103, .32)' : ''
                "
                variant="flat"
              >
                {{ $helpers.capitalize(item.status) }}
              </v-chip>
            </template>

            <template v-if="isAuthenticated" #[`item.actions`]="{ item }">
              <div class="action-icons">
                <v-menu
                  v-if="
                    item.cid == churchid ||
                    checkAuthorization(['superAdmin']).length > 0
                  "
                  location="top"
                >
                  <template #activator="{ props }">
                    <v-icon v-bind="props" class="mr-6"> eye </v-icon>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="lang in getAvailableLanguages(item)"
                      :key="lang.code"
                      @click="previewUnitInLanguage(item, lang.code)"
                    >
                      <template #prepend>
                        <v-chip
                          size="x-small"
                          :color="getLanguageColor(lang.code)"
                          variant="outlined"
                          class="mr-2"
                        >
                          {{ lang.code.toUpperCase() }}
                        </v-chip>
                      </template>
                      <v-list-item-title>{{ lang.name }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="getAvailableLanguages(item).length === 0"
                      disabled
                    >
                      <v-list-item-title
                        >{{ $t('units.noContentAvailable') }}</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-icon
                  v-if="
                    !isHelpDesk() &&
                    (item.cid == churchid ||
                      checkAuthorization(['superAdmin']).length > 0)
                  "
                  @click.native="loadUnitToEdit(item)"
                  class="mr-6"
                  >edit</v-icon
                >
                <v-icon
                  v-if="
                    (item.cid == churchid ||
                      checkAuthorization(['superAdmin']).length > 0) &&
                    !isHelpDesk()
                  "
                  @click.native="deleteItem(item, 'units')"
                  >delete_icon</v-icon
                >
              </div>
            </template>
          </v-data-table>
        </div>
      </v-flex>
      <v-snackbar
        v-model="snackbar"
        color="#592892"
        :timeout="timeout"
        location="top"
        class=""
      >
        <span v-html="snackbarMsg"></span>

        <template #actions="{ attrs }">
          <v-btn
            variant="text"
            v-bind="attrs"
            @click="snackbar = false"
            class="font-weight-bold"
          >
            {{ $t('units.snackbarClose') }}
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
  import db from '@/firebase/init'
  import { scopeToChurch } from '@/helpers/churchScope'
  import HowToUseThisPage from '@/components/utilities/HowToUseThisPage'
  import NewUnit from '@/components/utilities/NewUnit'
  import EditUnit from '@/components/utilities/EditUnit'
  import { mapGetters } from 'vuex'
  import { confirmAction } from '@/components/utilities/SwalService'
  import Swal from 'sweetalert2'
  import BookMark from '@/assets/icons/BookMark.vue'
  import { currentTheme } from '@/plugins/vuetify'
  import { openPreview } from '@/helpers/previewBridge'
  import { matchesConfirmWord } from '@/helpers/confirmWord'

  export default {
    name: 'Units',
    components: {
      HowToUseThisPage,
      NewUnit,
      EditUnit,
      BookMark,
    },
    data() {
      return {
        snackbar: false,
        snackbarMsg: '',
        feedback: null,
        units: [],
        sections: [],
        courses: [],
        allCategories: [],
        openUnitsForm: false,
        editingUnit: false,
        isEditingUnit: false,
        timeout: 6000,
        isloading: true,
        unitToEdit: null,
        unitbackdoor: 0,
        search: '',
        thePreviewUnit: [],
        prevType: '',
        prevStatus: '',
      }
    },
    computed: {
      churchid() {
        return this.$store.getters['AppData/cid']
      },
      ...mapGetters('UserData', ['isAuthenticated']),
      iconColor() {
        return currentTheme.value === 'dark' ? '#cecece' : '#383935'
      },
      isDarkTheme() {
        return currentTheme.value === 'dark'
      },
      adminActions() {
        let h = [
          {
            title: this.$t('units.tableHeaders.unit'),
            sortable: true,
            key: 'title',
          },
          {
            title: this.$t('units.tableHeaders.cid'),
            sortable: true,
            key: 'cid',
          },
          {
            title: this.$t('units.tableHeaders.type'),
            sortable: true,
            key: 'type',
          },
          {
            title: this.$t('units.tableHeaders.status'),
            sortable: true,
            key: 'status',
          },
          {
            title: this.$t('units.tableHeaders.sections'),
            sortable: false,
            key: 'sections',
          },
          {
            title: this.$t('units.tableHeaders.courses'),
            sortable: false,
            key: 'courses',
          },
          {
            title: this.$t('units.tableHeaders.actions'),
            sortable: false,
            key: 'actions',
            align: 'end',
          },
        ]
        if (this.isAuthenticated) {
          if (this.checkAuthorization(['admin']).length > 0)
            h = [
              {
                title: this.$t('units.tableHeaders.unit'),
                sortable: true,
                key: 'title',
              },
              {
                title: this.$t('units.tableHeaders.type'),
                sortable: true,
                key: 'type',
              },
              {
                title: this.$t('units.tableHeaders.status'),
                sortable: true,
                key: 'status',
              },
              {
                title: this.$t('units.tableHeaders.sections'),
                sortable: false,
                key: 'sections',
              },
              {
                title: this.$t('units.tableHeaders.courses'),
                sortable: false,
                key: 'courses',
              },
              {
                title: this.$t('units.tableHeaders.actions'),
                sortable: false,
                key: 'actions',
                align: 'end',
              },
            ]
        }
        return h
      },
    },
    watch: {
      churchid: {
        deep: true,
        handler(event) {
          this.getUnits(event)
        },
      },
    },
    methods: {
      addNewHandler() {
        localStorage.removeItem('accountStudyQuestions')
        localStorage.removeItem('equipStudyQuestions')
        localStorage.removeItem('truthStudyQuestions')
        localStorage.removeItem('truthVersesQuotes')

        this.unitToEdit = ''

        if (this.editingUnit) {
          if (this.$refs.addeditunitform) this.$refs.addeditunitform.reset()
          this.openUnitsForm = true
        } else {
          this.openUnitsForm = !this.openUnitsForm
        }
        this.editingUnit = false
        // console.log('this.openGroupForm ', this.openGroupForm)
      },
      addUnit() {
        if (this.unitTitle && this.unitSubtitle) {
          db.collection('units')
            .add({
              title: this.unitTitle,
              subtitle: this.unitSubtitle,
            })
            .then(() => {
              // Reset fields
              this.unitTitle = ''
              this.unitSubtitle = ''
              this.openUnitsForm = false

              // re-init the units list
              this.getUnits(this.$store.getters['AppData/cid'])
            })
        } else {
          this.feedback = 'You need to have a Unit title and a subtitle'
        }
      },
      checkAuthorization(permissions) {
        const userRoles = this.$store.getters['UserData/getRoles']
        if (permissions && userRoles) {
          const normalizedPermissions = permissions.includes('superAdmin')
            ? [...permissions, 'helpDesk']
            : permissions

          const hasRole = normalizedPermissions.filter(() =>
            userRoles.some((role) => normalizedPermissions.includes(role))
          )
          return hasRole
        }
      },
      isHelpDesk() {
        const userRoles = this.$store.getters['UserData/getRoles']
        return Array.isArray(userRoles) && userRoles.includes('helpDesk')
      },
      closebuilder() {
        this.unitToEdit = ''
        this.editingUnit = false
        this.openUnitsForm = false
      },
      closeUnitsFormChild(value) {
        // console.log(value)
        // used to close the New Unit form after a successful save
        this.openUnitsForm = !value.closeUnitsForm
        this.snackbar = true
        this.timeout = 4000
        this.snackbarMsg = this.$t('units.unitCreatedSuccess', { title: value.title })
        this.getUnits(this.$store.getters['AppData/cid'])
      },
      closeEditUnitsFormChild(value) {
        // console.log('closeEditUnitsFormChild ', value)
        this.editingUnit = !value.closeEditUnitsForm
        this.snackbar = true
        this.timeout = 4000
        this.snackbarMsg = this.$t('units.unitEditedSuccess', { title: value.title })
        this.getUnits(this.$store.getters['AppData/cid'])
      },
      coursesUsingThisUnit(item) {
        return this.courses.filter((course) =>
          course.units.find((unit) => unit.id == item.id)
        ).length
      },
      hasLocalizedContent(item, language) {
        // Check if the unit has localizedContent with content in the specified language
        if (!item.localizedContent || !item.localizedContent[language]) {
          return false
        }

        const localizedData = item.localizedContent[language]

        // Check if any of the key content fields have data
        const hasContent =
          localizedData.title ||
          localizedData.subtitle ||
          localizedData.description ||
          localizedData.truthBodyContent ||
          localizedData.equipBodyContent ||
          localizedData.accountBodyContent ||
          (localizedData.truthStudyQuestions &&
            localizedData.truthStudyQuestions.length > 0) ||
          (localizedData.equipStudyQuestions &&
            localizedData.equipStudyQuestions.length > 0) ||
          (localizedData.accountStudyQuestions &&
            localizedData.accountStudyQuestions.length > 0) ||
          (localizedData.truthVersesQuotes &&
            localizedData.truthVersesQuotes.length > 0)

        return hasContent
      },
      getAvailableLanguages(item) {
        // Get all languages that have content for this unit
        const availableLanguages = []
        const supportedLanguages = [
          { code: 'en', name: 'English' },
          { code: 'pt', name: 'Português' },
          { code: 'es', name: 'Español' },
          { code: 'fr', name: 'Français' },
          { code: 'de', name: 'Deutsch' },
          // Add more languages as needed
        ]

        supportedLanguages.forEach((lang) => {
          if (this.hasLocalizedContent(item, lang.code)) {
            availableLanguages.push(lang)
          }
        })

        return availableLanguages
      },
      getLanguageColor(languageCode) {
        // Predefined colors for common languages (for consistency)
        const predefinedColors = {
          en: 'blue',
          pt: 'green',
          es: 'orange',
          fr: 'purple',
          de: 'red',
          it: 'pink',
          nl: 'indigo',
          ru: 'teal',
          zh: 'amber',
          ja: 'cyan',
          ko: 'lime',
          ar: 'brown',
        }

        // If we have a predefined color, use it
        if (predefinedColors[languageCode]) {
          return predefinedColors[languageCode]
        }

        // Auto-generate color for new languages
        return this.generateColorForLanguage(languageCode)
      },
      generateColorForLanguage(languageCode) {
        // Create a consistent color based on the language code
        const colors = [
          'deep-orange',
          'deep-purple',
          'light-blue',
          'light-green',
          'deep-pink',
          'yellow',
          'grey',
          'brown',
          'amber',
          'cyan',
          'lime',
          'indigo',
          'pink',
          'purple',
          'red',
          'orange',
          'green',
          'blue',
          'teal',
          'amber',
        ]

        // Use the language code to generate a consistent hash
        let hash = 0
        for (let i = 0; i < languageCode.length; i++) {
          const char = languageCode.charCodeAt(i)
          hash = (hash << 5) - hash + char
          hash = hash & hash // Convert to 32-bit integer
        }

        // Use absolute value and modulo to get a consistent index
        const colorIndex = Math.abs(hash) % colors.length
        return colors[colorIndex]
      },
      async deleteItem(item, collection) {
        if (this.isHelpDesk && this.isHelpDesk()) {
          this.feedback = this.$t('units.deleteNotAllowed')
          return
        }

        if (!item || !collection) {
          Swal.fire({
            title: this.$t('units.houstonProblem'),
            text: this.$t('units.deleteErrorMissingParams'),
            icon: 'error',
            confirmButtonClass:
              'v-btn v-btn--contained theme--dark v-size--default v-btn--depressed',
          })
          return
        }

        const title = collection === 'units' ? item.title : item.id

        const confirmed = await confirmAction({
          title: this.$t('units.deleteConfirmTitle', { title }),
          html: this.$t('units.deleteConfirmText'),
          input: 'text',
          inputPlaceholder: this.$t('units.deleteConfirmPlaceholder'),
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (matchesConfirmWord(value, 'DELETE')) {
                resolve()
              } else {
                resolve(this.$t('units.needToTypeDelete'))
              }
            })
          },
          confirmButtonText: this.$t('units.deleteConfirmButton'),
          cancelButtonText: this.$t('units.deleteCancelButton'),
          context: this,
          buttonsStyling: false,
          customClass: {
            confirmButton:
              'swal-confirm-btn text-white text-uppercase text-body-2',
            cancelButton:
              'swal-cancel-btn text-white text-uppercase text-body-2',
          },
        })

        if (!confirmed) return

        try {
          await db.collection(collection).doc(item.id).delete()
          this.openUnitsForm = false
          this.editingUnit = false
          this.snackbar = true
          this.timeout = 3000
          this.snackbarMsg = this.$t('units.unitDeletedSuccess', { title })
          this.getUnits(this.$store.getters['AppData/cid'])
        } catch (err) {
          console.error('Error deleting unit:', err)
        }
      },
      inputHandler(unit, key) {
        // console.log('inputHandler ', this.unitToEdit)
        if (this.editingUnit) {
          this.onTextChange(unit, key)
        }
      },
      loadUnitToEdit(unit) {
        // console.log('u ', unit)
        this.unitbackdoor++
        this.openUnitsForm = false
        this.unitToEdit = unit
        this.editingUnit = true
        this.prevType = unit.type
        this.prevStatus = unit.status

        localStorage.removeItem('accountStudyQuestions')
        localStorage.removeItem('equipStudyQuestions')
        localStorage.removeItem('truthStudyQuestions')
        localStorage.removeItem('truthVersesQuotes')

        if (unit.accountStudyQuestions && unit.accountStudyQuestions.length > 0)
          localStorage.setItem(
            'accountStudyQuestions',
            JSON.stringify(unit.accountStudyQuestions)
          )

        if (unit.equipStudyQuestions && unit.equipStudyQuestions.length > 0)
          localStorage.setItem(
            'equipStudyQuestions',
            JSON.stringify(unit.equipStudyQuestions)
          )

        if (unit.truthStudyQuestions && unit.truthStudyQuestions.length > 0)
          localStorage.setItem(
            'truthStudyQuestions',
            JSON.stringify(unit.truthStudyQuestions)
          )

        if (unit.truthVersesQuotes && unit.truthVersesQuotes.length > 0)
          localStorage.setItem(
            'truthVersesQuotes',
            JSON.stringify(unit.truthVersesQuotes)
          )

        this.snackbar = true
        this.timeout = 2000
        this.snackbarMsg = this.$t('units.unitEditing', { title: unit.title })

        this.scrollToTop()
      },
      previewUnit(unit) {
        openPreview(this.$router, this.$route, {
          name: 'PreviewUnit',
          id: unit.id,
          lang: 'en',
        })
      },
      previewUnitInLanguage(unit, languageCode) {
        openPreview(this.$router, this.$route, {
          name: 'PreviewUnit',
          id: unit.id,
          lang: languageCode,
        })
      },
      save(item) {
        // console.log('save ',item)
        const statusIndicator = document.querySelectorAll(
          '.snippet-autosave-status, .quillWrapper'
        )

        // Lets debouce this
        if (this.timeout) clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
          // your action
          db.collection('units')
            .doc(item.id)
            .update({
              title: item.title,
              subtitle: item.subtitle,
            })
            .then(() => {
              // set time out is only used for user experience
              // setTimeout(() => {
              statusIndicator.forEach(function (item) {
                item.classList.remove('busy')
              })
              // }, 300);
            })
            .catch((err) => {
              console.log(err)
            })
        }, 300)
      },
      sectionsUsingThisUnit(item) {
        return this.sections.filter((section) =>
          section.units.find((unit) => unit.id == item.id)
        ).length
      },
      scrollToTop() {
        document.getElementById('units').scrollIntoView({ behavior: 'smooth' })
      },
      sortSections(dir) {
        if (dir == 'ASC') {
          this.units.sort((a, b) =>
            a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1
          )
        }
        if (dir == 'DESC') {
          this.units.sort((a, b) =>
            a.title.toLowerCase() < b.title.toLowerCase() ? 1 : -1
          )
        }
        if (dir == 'clear') {
          this.getUnits(this.$store.getters['AppData/cid'])
        }
      },
      togglePanel(index) {
        if (this.openedPanel == index) {
          this.openedPanel = null
        } else {
          this.openedPanel = index
        }
      },
      init() {
        this.isloading = true
        this.openUnitsForm = false
        this.editingUnit = false
        // console.log('init called')
        // we set a timeout for the User experience
        setTimeout(() => {
          this.sections = []
          let sectionsRef = db.collection('sections')
          sectionsRef
            .get()
            .then((snapshot) => {
              snapshot.forEach((doc) => {
                let section = doc.data()
                section.id = doc.id
                this.sections.push(section)
              })
            })
            .then(() => {
              this.courses = []
              let coursesRef = scopeToChurch(
                db.collection('courses'),
                this.$store
              )
              coursesRef.get().then((snapshot) => {
                snapshot.forEach((doc) => {
                  let course = doc.data()
                  course.id = doc.id
                  this.courses.push(course)
                })
              })
            })
            .then(() => {
              this.allCategories = []
              let catRef = db.collection('categories')
              catRef.get().then((snapshot) => {
                snapshot.forEach((doc) => {
                  let cat = doc.data()
                  cat.id = doc.id
                  this.allCategories.push(cat)
                })
              })
            })
            .then(() => {
              this.isloading = false
              // console.log(this.units)
            })
        }, 1000)
      },
      getUnits(cid) {
        // console.log('getUnits ', cid)
        let unitsRef = db.collection('units')
        unitsRef.get().then((snapshot) => {
          // let unitsRef = db.collection('units')
          // unitsRef.onSnapshot(snapshot => {
          this.units = []
          snapshot.forEach((snap) => {
            let unit = snap.data()
            unit.id = snap.id
            // this.units.push(unit)

            if (cid === null || cid === undefined) {
              if (
                this.isAuthenticated &&
                this.checkAuthorization(['superAdmin']).length > 0
              )
                this.units.push(unit)
            } else {
              if (
                (this.isAuthenticated &&
                  this.checkAuthorization(['superAdmin']).length > 0 &&
                  !unit.cid) ||
                (unit.cid && unit.cid == cid)
              ) {
                this.units.push(unit)
              }
            }

            if (
              this.isAuthenticated &&
              !this.checkAuthorization(['superAdmin']).length > 0
            ) {
              this.units.sort((a) => {
                if (a.cid) return -1
                return 0
              })
            } else {
              this.units.sort((a, b) => (a.order > b.order ? 1 : -1))
            }
          })

          this.init()
        })
      },
    },
    created() {
      this.getUnits(this.$store.getters['AppData/cid'])
    },
  }
</script>

<style>
  .units-container {
    margin-top: 50px;
    margin-bottom: 25%;
  }
  /* .units-container trix-editor {
    background: #fff;
  } */
  .units-container .units-icon {
    margin-right: 10px;
  }
  .units-container .builder-title {
    font-size: 32px;
  }
  .units-container .v-expansion-panels {
    justify-content: flex-start;
  }
  .units-container .v-expansion-panel > div {
    width: 100%;
  }
  .units-container .v-expansion-panel__header {
    cursor: grab;
  }
  .units-container .v-expansion-panel {
    border: none;
  }
  .v-table__wrapper table th:last-child,
  .v-table__wrapper table td:last-child {
    width: 150px;
    text-align: right;
  }
</style>
